export enum ParagraphType {
  IMAGE = 'image',
  TEXT = 'text',
}

export interface IParagraph {
  content: string;
  type: ParagraphType;
}

export interface IArticle {
  id: number;
  title: string;
  date: string;
  paragraph: IParagraph[];
}
